<template>
    <div class="holder">
        <p class="main-img-holder">
            <img v-bind:key="cv.imgUrl" class="img-circle" :src="cv.imgUrl"/>
        </p>
        <div>
            <h1 class="title"> {{cv.name}} </h1>
        </div>
        <div id="cv">
            <div class="main">
                <!-- <h1 class="title"> {{cv.name}} </h1> -->
                <h2 class="subtitle"> {{strings.professionalSummary}} </h2>
                <p class="excerpt">
                    {{cv.excerpt}}
                </p>

                <h2 class="subtitle"> {{strings.experience}} </h2>

                <div class="timeline">
                    <div class="experience" v-for="exp in cv.experiencies" :key="exp.jobTitle">
                        <p class="job-title">
                            {{exp.jobTitle}}
                            <i class="duration"> {{exp.from}} <span v-if="exp.to && exp.to.length"> - </span>
                                {{exp.to}}</i>
                        </p>
                        <p class="where"> {{exp.where}}</p>

                        <ul>
                            <li v-for="item in exp.items" :key="item">
                                <p> {{item}} </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <h2 class="subtitle">{{strings.academic}}</h2>
                <div class="timeline">
                    <div class="experience" v-for="academy in cv.academic" :key="academy.title">
                        <p class="job-title">
                            {{academy.title}}
                        </p>
                        <p class="when"> {{academy.date}}</p>
                        <p class="where"> {{academy.description}}, <i> {{academy.place}} </i></p>
                    </div>
                </div>
            </div>
            <div class="side">
                <div class="content">
                    <div class="sec-img-holder">
                        <img v-bind:key="cv.imgUrl" class="img-circle" :src="cv.imgUrl"/>
                    </div>
                    <div class="section contact-big">
                        <Contact
                                :cv="cv"
                                :strings="strings"
                        ></Contact>
                    </div>
                    <div v-for="section in cv.sections" class="section" :key="section.title">
                        <h2 class="subtitle"> {{section.title}} </h2>
                        <ul>
                            <li v-for="item in section.items" :key="item">
                                {{item}}
                            </li>
                        </ul>
                    </div>
                    <div class="section contact-small">
                        <Contact
                                :cv="cv"
                                :strings="strings"
                        ></Contact>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Contact from "./Contact";

    export default {
        name: 'cv',
        components: {Contact},
        props: ['cv', 'strings']
    }
</script>

<style lang="scss">

    ul {
        padding-inline-start: 20px;

        > li > p {
            margin: 5px;
        }
    }

    .holder {
        font-size: 20px;
        background-color: white;
        padding: 10px 100px;
        height: 100%;
        min-height: 100%;
        flex-direction: column;

        @media (max-width: 1024px) {
            padding: 0 10px;
        }
    }


    #cv {
        background-color: white;
        display: flex;
        text-align: justify;
        flex-wrap: wrap;
        font-family: SourceSansPro;
    }

    .main {
        flex: 2;
        padding-right: 20px;
        height: 100%;

        @media (max-width: 1000px) {
            width: 100% !important;
        }

        @media (min-width: 1024px) {
            min-width: 500px;
        }
    }

    .side {
        flex: 1;
        display: flex;
        justify-content: center;

        > .content {
            @media (max-width: 768px) {
                margin-top: 20px;
            }
            max-width: 400px;
        }

        @media (max-width: 768px) {
            min-width: 100% !important;
        }
    }

    .main-img-holder {
        text-align: center;
        @media (min-width: 1025px) {
            display: none;
        }
    }

    .sec-img-holder {
        position: absolute;
        right: 12%;
        top: 40px;
        @media (max-width: 1024px) {
            display: none;
        }
    }

    .img-circle {
        width: 150px;
        height: 150px;
        object-fit: contain;
        border: 1px solid lightgray;
        border-radius: 100%;
        background-color: white;
    }

    .title {
        text-align: left;
        font-weight: 100 !important;
        font-family: DMSerifDisplay;
    }

    .subtitle {
        color: #305fec;
        font-size: 24px;
        font-weight: 100 !important;
        font-family: DMSerifDisplay;
        margin-top: 0;
    }

    .job-title {
        font-weight: bolder;
        text-align: left;
        margin-bottom: 0;
        margin-top: 0;
    }

    .duration {
        font-weight: normal;
        font-size: 14px;
        color: gray;
    }

    .timeline {
        margin-left: 10px;
        border-left: 1px solid lightgray;
        padding-left: 10px;
        position: relative;

        .when {
            font-size: 14px;
            margin: 0;
            color: gray;
        }

        .where {
            font-size: 14px;
            margin-top: 5px;
        }

    }

    .experience {
        margin-left: 20px;
        position: relative;
    }

    .job-title:before {
        content: '';
        width: 12px;
        height: 12px;
        border-radius: 100%;
        position: absolute;
        left: -40px;
        top: 3px;
        background-color: white;
        border: 3px solid #305fec;
    }

    .experience:first-child::before {
        content: '';
        width: 12px;
        height: 3px;
        position: absolute;
        left: -37px;
        background-color: white;
    }

    .section {
        border: 1px solid #d0d0d0;
        padding: 15px;
        margin-bottom: 25px;
    }

    .icon {
        min-width: 50px;
    }

    .separator {
        width: 100%;
        height: 2px;
        margin: 0;
        background-color: lightgray;
    }

    .contact-small {
        @media (min-width: 768px) {
            display: none;
        }
    }

    .contact-big {
        @media (max-width: 768px) {
            display: none;
        }
    }

    .link {
        text-decoration: none;
        font-weight: 100;
    }

</style>
